<template>
  <div class="container">
    <div v-if="state?.apply_status === undefined" class="wrap">
      <div class="bg-desc">
        <div class="img"></div>
        <span>轻松实现直播间下单锁客</span>
      </div>
      <div class="form-wrap">
        <div class="form-item">
          <div class="form-label">
            <span>填写您的微信号</span>
            <div class="desc" @click="Dialog({ message: '退出小程序-返回微信-我的-即可查看微信号' })">
              <van-icon name="question-o" />
              <span>如何获取微信号</span>
            </div>
          </div>
          <van-field class="input" :maxlength="20" v-model="weixin_no" placeholder="填写您想申请分享员的微信号" />
        </div>
        <div class="btn-wrap">
          <div class="btn-desc">
            <span>每个微信号</span>
            <span class="imp">仅能申请一次</span>
            <span>，请认真核对微信号哦</span>
          </div>
          <van-button :disabled="!weixin_no || weixin_no.length < 6" class="btn" type="primary" @click="handleSubmit"
            >提交申请</van-button
          >
        </div>
      </div>
    </div>
    <StatusMark v-else :state="state" @handlApply="handlApply" />
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import { getSharerApply, setApplySharer } from '@/api/sph'
import StatusMark from './component/StatusMark.vue'
import { Dialog } from '@vant/compat'

const weixin_no = ref()
const state = ref({ apply_status: null })

const handleSubmit = async () => {
  await setApplySharer({ weixin_no: weixin_no.value })
  getInfo()
}

const handlApply = () => (state.value.apply_status = undefined)

async function getInfo() {
  const { info } = await getSharerApply()
  state.value = info
  if (info.bind_status === 1) state.value.apply_status = 3
  else if (info.bind_status === 2) {
    state.value.apply_status = 4
    state.value.audit_remark = info.bind_remark
  }
}

onMounted(getInfo())
</script>

<style lang="less" scoped>
.container {
  background: #ffffff;

  .wrap {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url('../../assets/img/applySharer_bg.png') no-repeat;
    background-size: cover;
    background-position: center center;

    .bg-desc {
      margin: 52px 0 0 17px;

      .img {
        width: 158px;
        height: 71px;
        margin-bottom: 11px;
        background: url('../../assets/img/applySharer_desc.png') no-repeat;
        background-size: cover;
      }

      span {
        font-size: 14px;
        color: #8188aa;
      }
    }

    .form-wrap {
      position: relative;
      margin-top: 70px;
      margin-left: 16px;
      padding: 20px 16px;
      width: 343px;
      height: 361px;
      background: linear-gradient(180deg, #ffffff 0%, #e8effd 100%);
      box-shadow: 0 -6px 10px 0 rgba(77, 128, 235, 0.04);
      border-radius: 20px;

      .form-item {
        .form-label {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          font-weight: bold;
          font-size: 14px;
          color: #555769;

          .desc {
            font-size: 11px;
            color: #999999;
            margin-left: auto;

            span {
              margin-left: 4px;
            }
          }
        }

        .input {
          width: 311px;
          height: 44px;
          border-radius: 8px;
          border: 1px solid #ccd0e6;
        }
      }
    }

    .btn-wrap {
      position: absolute;
      width: 100%;
      bottom: 0;
      font-size: 12px;
      color: #999999;

      .btn-desc {
        display: flex;
        justify-content: center;
        margin-bottom: 16px;
      }

      .imp {
        color: #4d7fec;
      }

      .btn {
        width: 311px;
        height: 48px;
        border-radius: 8px;
      }
    }
  }
}
</style>
